import React, { useState } from 'react';
import Prism from 'prismjs';
import Editor from 'react-simple-code-editor';
import styled from 'styled-components';

import 'prismjs/themes/prism.css';

type JSONEditorProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export default function JSONEditor({ value, onChange, disabled = false }: JSONEditorProps) {
  const [focused, setFocused] = useState(false);

  return (
    <EditorContainer $focused={focused} $disabled={disabled}>
      <StyledEditor
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        value={value}
        onValueChange={onChange}
        highlight={(code) => Prism.highlight(code, Prism.languages.javascript, 'javascript')}
        padding={10}
        readOnly={disabled}
        tabSize={2}
      />
    </EditorContainer>
  );
}

const EditorContainer = styled.div<{ $focused: boolean; $disabled: boolean }>`
  max-height: 200px;
  min-height: 118px;
  overflow: auto;
  box-sizing: border-box;
  border: 1px solid
    ${({ $focused, $disabled }) => ($disabled ? 'transparent' : $focused ? 'var(--primary-blue)' : 'var(--black-25)')};
  border-radius: 4px;
  background-color: ${({ $disabled }) => ($disabled ? 'var(--black-10)' : 'white')};
  font-family: monospace;
  font-size: 13px;
  line-height: 18px;
  width: 100%;

  & > * textarea {
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'inherit')};
    outline: none;
  }
`;

const StyledEditor = styled(Editor)`
  min-height: 118px;
  resize: none;
`;
